import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_flex _ai-c _gap-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($options.wrapperClassList)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "_flex _ai-c _gap-1 _cur-p _grow-1",
        onClick: _cache[0] || (_cache[0] = (...args) => ($options.toggleExpand && $options.toggleExpand(...args))),
        "data-qa": "collapsible:trigger"
      }, [
        _renderSlot(_ctx.$slots, "trigger", { isExpanded: $options.isExpandedComputed }, () => [
          _createVNode(_component_base_icon, { name: $options.iconName }, null, 8 /* PROPS */, ["name"])
        ])
      ]),
      _renderSlot(_ctx.$slots, "header-content")
    ]),
    _createElementVNode("div", {
      class: _normalizeClass($options.contentClassList),
      "data-qa": "collapsible:content"
    }, [
      _renderSlot(_ctx.$slots, "content")
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}